export interface FrameworkMacro { name: string; category: string; description: string; }
export interface BuildConfiguration { id: string; label: string; source: string; active: string[]; commented: string[]; note: string; }
export type MacroStatus = 'active' | 'commented' | 'absent';
export const analysisDate = '2026-11-05';
export const defaultConfiguration = 'adddi_rk3588_cmsv2_media_test';
export const macros: FrameworkMacro[] = [
  {
    "name": "ENGINE",
    "category": "추론 백엔드",
    "description": "NVIDIA TensorRT engine 추론 백엔드 선택."
  },
  {
    "name": "RKNN",
    "category": "추론 백엔드",
    "description": "Rockchip RKNN NPU 추론 백엔드 선택."
  },
  {
    "name": "ONNX",
    "category": "추론 백엔드",
    "description": "ONNX 추론 백엔드 선택."
  },
  {
    "name": "DEBUG",
    "category": "개발·시각화",
    "description": "개발용 경로와 장치 식별값 사용. 일부 네트워크 처리와 실시간 로그 업로드 생략. 분석 파일 로컬 보존."
  },
  {
    "name": "SHOW_ALL",
    "category": "개발·시각화",
    "description": "SHOW, SHOW_EWA, SHOW_GAZE, SHOW_EVENT를 활성화. 추적 결과, 노출·주시·집중 시간, 시선, 이벤트 시각화. 관련 분석 기능이 켜져 있어야 해당 시각화가 동작."
  },
  {
    "name": "BYTE_TRACKER",
    "category": "추적·속성 분석",
    "description": "ByteTrack 방식 추적 사용. 미정의 시 IoU 추적 경로 사용."
  },
  {
    "name": "ATTRIBUTE_FULL_BODY",
    "category": "추적·속성 분석",
    "description": "속성 분석용 이미지를 객체 전체 영역에서 추출."
  },
  {
    "name": "ATTRIBUTE_HEAD",
    "category": "추적·속성 분석",
    "description": "속성 분석용 이미지를 머리 영역에서 추출. 키포인트가 없으면 전체 영역으로 대체."
  },
  {
    "name": "POSE_WITH_CAR_DETECTOR",
    "category": "추적·속성 분석",
    "description": "사람 포즈 모델과 차량 검출 모델을 함께 실행하여 결과 결합."
  },
  {
    "name": "WATCH_TOP_DOWN",
    "category": "추적·속성 분석",
    "description": "코와 양쪽 귀 위치를 이용하여 아래 방향 피치 영역을 주시로 인정하는 판정 적용."
  },
  {
    "name": "CAMERA_NUMBER",
    "category": "장치·운영·API",
    "description": "카메라 번호 기반 장치 식별 및 API 처리."
  },
  {
    "name": "HW_MONITOR",
    "category": "장치·운영·API",
    "description": "하드웨어 상태 모니터링 및 상태 로그 전송."
  },
  {
    "name": "REMOTE_CONFIG",
    "category": "장치·운영·API",
    "description": "장치 정보 API의 주시 각도, 주시 시간, 집중 시간 설정 반영."
  },
  {
    "name": "API_V2",
    "category": "장치·운영·API",
    "description": "V2 장치 플래그 API와 실시간 분석 데이터 업로드 경로 선택. 제품별 예외 존재."
  },
  {
    "name": "PERSISTENT",
    "category": "장치·운영·API",
    "description": "메인 프로세스 재시작 횟수 제한을 없애고 지속 실행 경로 사용."
  },
  {
    "name": "RTSP",
    "category": "영상 입력·저장",
    "description": "API에서 받은 RTSP URL로 연결. URL이 비어 있으면 로컬 카메라 사용."
  },
  {
    "name": "V_FLIP_FRAME",
    "category": "영상 입력·저장",
    "description": "영상 상하 반전 활성화. 원격 설정 수신 시에도 강제 유지."
  },
  {
    "name": "RECORD_SDCARD",
    "category": "영상 입력·저장",
    "description": "녹화 저장 위치를 /mnt/sdcard로 설정. 녹화 자체 활성화와 별개."
  },
  {
    "name": "FISHEYE_TO_PANORAMA",
    "category": "영상 입력·저장",
    "description": "어안 영상을 파노라마로 변환. 분석 영상 크기 1600×400."
  },
  {
    "name": "SNAPSHOT_43",
    "category": "영상 입력·저장",
    "description": "카메라 스냅샷을 1280×960, 4:3으로 생성."
  },
  {
    "name": "EVENT_OOI",
    "category": "이벤트·분석 출력",
    "description": "관심 대상(Object of Interest)을 바라보는 시선 이벤트 판정."
  },
  {
    "name": "EVENT_SECURITY",
    "category": "이벤트·분석 출력",
    "description": "배회·낙상·무단횡단 등 보안 이벤트 판정. ROI와 제품 설정에 따라 동작."
  },
  {
    "name": "VEHICLE_CSV",
    "category": "이벤트·분석 출력",
    "description": "차량 분석 CSV 생성 및 업로드 경로 활성화."
  },
  {
    "name": "COORD",
    "category": "이벤트·분석 출력",
    "description": "객체 좌표, 이동 궤적, 시선·몸 방향 관련 데이터 수집 및 JSON 출력."
  },
  {
    "name": "CSV_WATCH_DIRECTION",
    "category": "이벤트·분석 출력",
    "description": "주시 이력에 대응하는 방향 정보를 별도 WATCH_DIRECTION CSV로 기록."
  },
  {
    "name": "CMS",
    "category": "CMS·화면 출력",
    "description": "기존 CMS 광고 다운로드, 스케줄 재생, 광고별 분석 처리."
  },
  {
    "name": "CMSV2",
    "category": "CMS·화면 출력",
    "description": "CMS V2 재생 모듈 활성화. GStreamer 기반 재생 및 스케줄 처리."
  },
  {
    "name": "CMSV2_SHOWROOM_PIP",
    "category": "CMS·화면 출력",
    "description": "쇼룸용 카메라·포즈 화면을 광고 영상 위에 PIP 또는 오버레이로 표시."
  },
  {
    "name": "CMSV2_CCW",
    "category": "CMS·화면 출력",
    "description": "CMS V2 영상을 반시계 방향 90도 회전."
  },
  {
    "name": "CMSV2_CW",
    "category": "CMS·화면 출력",
    "description": "CMS V2 영상을 시계 방향 90도 회전."
  },
  {
    "name": "CMSV2_180",
    "category": "CMS·화면 출력",
    "description": "CMS V2 영상을 180도 회전."
  },
  {
    "name": "CMSV2_WITH_AUDIO",
    "category": "CMS·화면 출력",
    "description": "영상 스케줄 시계에 맞춘 오디오 재생 모듈 활성화."
  },
  {
    "name": "SHOWROOM_RK3588_CMS_V2",
    "category": "CMS·화면 출력",
    "description": "분석 입력 해상도를 쇼룸용 1920×1080으로 설정."
  },
  {
    "name": "ADDDI_BASIC",
    "category": "제품별",
    "description": "BASIC 제품명, 추적 유지 시간·IoU·집중 시간 튜닝. 성별·연령을 지정 확률 분포의 난수로 대체하는 분기 포함."
  },
  {
    "name": "ADDDI_BASIC_MONGYU",
    "category": "제품별",
    "description": "몽유 제품명 선택용. 제공된 구성에서는 ADDDI_BASIC도 정의되어 제품명은 BASIC이 우선."
  },
  {
    "name": "ADDDI_LIGHT_GTX",
    "category": "제품별",
    "description": "GTX 제품명 및 제품별 성별·연령 난수 분포 적용."
  },
  {
    "name": "ADDDI_LIGHT_SBA",
    "category": "제품별",
    "description": "SBA 전용 장치 식별·API·군중 스냅샷 CSV 처리. COORD 해제, 제품별 이벤트·로그 경로 적용."
  },
  {
    "name": "ADDDI_CMS_INCHEON_HANGMAN",
    "category": "제품별",
    "description": "인천항만 제품명 및 CMS 스케줄 전환. 검출 객체가 10개 이상이면 이벤트 스케줄 선택."
  },
  {
    "name": "ADDDI_RK3566",
    "category": "제품별",
    "description": "RK3566 제품명, 추적·집중 시간 및 성별·연령 처리용 분포 설정."
  },
  {
    "name": "ADDDI_RK3588_CMSV2_SHOWROOM",
    "category": "제품별",
    "description": "쇼룸 제품명, 추적·집중 시간 및 속성 처리용 설정. CMS와 PIP 활성화는 별도 매크로 담당."
  },
  {
    "name": "ADDDI_RK3588_CMSV2_MEDIA_TEST",
    "category": "제품별",
    "description": "Media-test 제품명, 추적·집중 시간 및 속성 처리용 설정."
  },
  {
    "name": "ADDDI_RK3588_ROBOTIS_ADROBOT",
    "category": "제품별",
    "description": "확인된 직접 분기는 제품명 선택. 어안 변환과 주시 방향 기록은 별도 매크로 담당."
  },
  {
    "name": "DALGOT",
    "category": "제품별",
    "description": "달고T 전용 GPS, 광고·분석 로그, EMS 연동, Redis 및 차량 추적 코드. 추적 파라미터와 성별·연령 난수 처리."
  },
  {
    "name": "DALGOT_JETSON",
    "category": "제품별",
    "description": "달고T Jetson용 GPS·EMS·로그·추적 설정과 성별·연령 난수 처리. DALGOT 전용 Redis 분기와 구분."
  },
  {
    "name": "SPACEI",
    "category": "제품별",
    "description": "SPACEI 전용 데이터·로그 처리 및 추적 파라미터 적용."
  },
  {
    "name": "MODELX",
    "category": "제품별",
    "description": "MODELX 제품명, 추적 임계값·집중 시간 설정과 성별·연령 난수 처리."
  },
  {
    "name": "MODELX_JAPAN_OSAKA",
    "category": "제품별",
    "description": "오사카 제품명, 입력 해상도 1536×832 및 사람 추적 임계값 조정."
  }
];
export const configurations: BuildConfiguration[] = [
  {
    "id": "adddi_basic",
    "label": "adddi_basic",
    "source": "app_main/CMakeLists.txt.adddi_basic",
    "active": [
      "ENGINE",
      "ATTRIBUTE_FULL_BODY",
      "BYTE_TRACKER",
      "CAMERA_NUMBER",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "API_V2",
      "EVENT_OOI",
      "EVENT_SECURITY",
      "COORD",
      "RTSP",
      "ADDDI_BASIC"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "adddi_basic_mongyu",
    "label": "adddi_basic_mongyu",
    "source": "app_main/CMakeLists.txt.adddi_basic_mongyu",
    "active": [
      "ENGINE",
      "RTSP",
      "API_V2",
      "HW_MONITOR",
      "CAMERA_NUMBER",
      "REMOTE_CONFIG",
      "ATTRIBUTE_FULL_BODY",
      "ADDDI_BASIC",
      "ADDDI_BASIC_MONGYU"
    ],
    "commented": [
      "BYTE_TRACKER"
    ],
    "note": ""
  },
  {
    "id": "adddi_cms_incheon_hangman",
    "label": "adddi_cms_incheon_hangman",
    "source": "app_main/CMakeLists.txt.adddi_cms_incheon_hangman",
    "active": [
      "ENGINE",
      "CMS",
      "CAMERA_NUMBER",
      "HW_MONITOR",
      "ATTRIBUTE_FULL_BODY",
      "ADDDI_CMS_INCHEON_HANGMAN"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "adddi_light_gtx",
    "label": "adddi_light_gtx",
    "source": "app_main/CMakeLists.txt.adddi_light_gtx",
    "active": [
      "ENGINE",
      "ATTRIBUTE_FULL_BODY",
      "BYTE_TRACKER",
      "CAMERA_NUMBER",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "API_V2",
      "EVENT_OOI",
      "EVENT_SECURITY",
      "VEHICLE_CSV",
      "COORD",
      "PERSISTENT",
      "ADDDI_LIGHT_GTX"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "adddi_light_sba",
    "label": "adddi_light_sba",
    "source": "app_main/CMakeLists.txt.adddi_light_sba",
    "active": [
      "RKNN",
      "V_FLIP_FRAME",
      "BYTE_TRACKER",
      "ATTRIBUTE_HEAD",
      "ADDDI_LIGHT_SBA",
      "API_V2",
      "EVENT_SECURITY"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "adddi_rk3566",
    "label": "adddi_rk3566",
    "source": "app_main/CMakeLists.txt.adddi_rk3566",
    "active": [
      "RKNN",
      "CAMERA_NUMBER",
      "BYTE_TRACKER",
      "API_V2",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "ATTRIBUTE_FULL_BODY",
      "ADDDI_RK3566"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "adddi_rk3588_cmsv2_media_test",
    "label": "media-test",
    "source": "app_main/CMakeLists.txt.adddi_rk3588_cmsv2_media_test",
    "active": [
      "RKNN",
      "CAMERA_NUMBER",
      "BYTE_TRACKER",
      "ATTRIBUTE_FULL_BODY",
      "API_V2",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "ADDDI_RK3588_CMSV2_MEDIA_TEST",
      "CMSV2"
    ],
    "commented": [
      "RTSP",
      "PERSISTENT",
      "CMSV2_WITH_AUDIO",
      "CMSV2_SHOWROOM_PIP",
      "CMSV2_CCW",
      "CMSV2_CW",
      "CMSV2_180"
    ],
    "note": ""
  },
  {
    "id": "adddi_rk3588_cmsv2_showroom",
    "label": "adddi_rk3588_cmsv2_showroom",
    "source": "app_main/CMakeLists.txt.adddi_rk3588_cmsv2_showroom",
    "active": [
      "RKNN",
      "RTSP",
      "PERSISTENT",
      "SHOWROOM_RK3588_CMS_V2",
      "CAMERA_NUMBER",
      "BYTE_TRACKER",
      "ATTRIBUTE_FULL_BODY",
      "API_V2",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "ADDDI_RK3588_CMSV2_SHOWROOM",
      "CMSV2",
      "CMSV2_SHOWROOM_PIP",
      "CMSV2_CCW"
    ],
    "commented": [
      "CMSV2_CW",
      "CMSV2_180"
    ],
    "note": ""
  },
  {
    "id": "adddi_rk3588_robotis_adrobot",
    "label": "adddi_rk3588_robotis_adrobot",
    "source": "app_main/CMakeLists.txt.adddi_rk3588_robotis_adrobot",
    "active": [
      "RKNN",
      "ADDDI_RK3588_ROBOTIS_ADROBOT",
      "CSV_WATCH_DIRECTION",
      "WATCH_TOP_DOWN",
      "RTSP",
      "CAMERA_NUMBER",
      "BYTE_TRACKER",
      "FISHEYE_TO_PANORAMA",
      "SNAPSHOT_43",
      "ATTRIBUTE_FULL_BODY",
      "API_V2",
      "HW_MONITOR",
      "REMOTE_CONFIG"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "dalgot",
    "label": "dalgot",
    "source": "app_main/CMakeLists.txt.dalgot",
    "active": [
      "ENGINE",
      "CAMERA_NUMBER",
      "DALGOT",
      "POSE_WITH_CAR_DETECTOR",
      "ATTRIBUTE_FULL_BODY",
      "BYTE_TRACKER"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "dalgot_jetson",
    "label": "dalgot_jetson",
    "source": "app_main/CMakeLists.txt.dalgot_jetson",
    "active": [
      "ENGINE",
      "RTSP",
      "HW_MONITOR",
      "CAMERA_NUMBER",
      "BYTE_TRACKER",
      "POSE_WITH_CAR_DETECTOR",
      "DALGOT_JETSON"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "host",
    "label": "host",
    "source": "app_main/CMakeLists.txt.host",
    "active": [
      "DEBUG",
      "ONNX",
      "SHOW_ALL",
      "ATTRIBUTE_FULL_BODY",
      "BYTE_TRACKER",
      "CAMERA_NUMBER",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "API_V2",
      "EVENT_OOI",
      "EVENT_SECURITY",
      "VEHICLE_CSV"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "modelx",
    "label": "modelx",
    "source": "app_main/CMakeLists.txt.modelx",
    "active": [
      "ENGINE",
      "ATTRIBUTE_FULL_BODY",
      "BYTE_TRACKER",
      "CAMERA_NUMBER",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "API_V2",
      "EVENT_OOI",
      "EVENT_SECURITY",
      "VEHICLE_CSV",
      "COORD",
      "PERSISTENT",
      "RTSP",
      "MODELX"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "modelx_japan_osaka",
    "label": "modelx_japan_osaka",
    "source": "app_main/CMakeLists.txt.modelx_japan_osaka",
    "active": [
      "ENGINE",
      "ATTRIBUTE_FULL_BODY",
      "BYTE_TRACKER",
      "CAMERA_NUMBER",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "API_V2",
      "EVENT_SECURITY",
      "VEHICLE_CSV",
      "COORD",
      "PERSISTENT",
      "RTSP",
      "MODELX_JAPAN_OSAKA"
    ],
    "commented": [
      "MODELX"
    ],
    "note": ""
  },
  {
    "id": "spacei",
    "label": "spacei",
    "source": "app_main/CMakeLists.txt.spacei",
    "active": [
      "ENGINE",
      "ATTRIBUTE_FULL_BODY",
      "BYTE_TRACKER",
      "CAMERA_NUMBER",
      "HW_MONITOR",
      "REMOTE_CONFIG",
      "API_V2",
      "EVENT_OOI",
      "EVENT_SECURITY",
      "VEHICLE_CSV",
      "COORD",
      "RECORD_SDCARD",
      "PERSISTENT",
      "SPACEI"
    ],
    "commented": [],
    "note": ""
  },
  {
    "id": "adddi_rk3588_cmsv2_kiosk",
    "label": "adddi_rk3588_cmsv2_kiosk",
    "source": "app_main/CMakeLists.txt.adddi_rk3588_cmsv2_kiosk",
    "active": [],
    "commented": [],
    "note": "활성 선언 없음. tests/dashboard/CMakeLists.txt를 include하는 독립 대시보드 구성."
  },
  {
    "id": "tests/dashboard/CMakeLists.txt",
    "label": "tests/dashboard/CMakeLists.txt",
    "source": "tests/dashboard/CMakeLists.txt",
    "active": [],
    "commented": [],
    "note": "활성 선언 없음."
  }
];
export const findings: { title: string; details: string[] }[] = [
  {
    "title": "- 아래 특이점을 근거와 함께 표시",
    "details": [
      "“확인된 동작”과 “빌드하지 않아 검증되지 않은 예상”을 구분"
    ]
  },
  {
    "title": "데이터 내보내기",
    "details": [
      "전체 분석 데이터 JSON 다운로드",
      "선택 구성의 활성 매크로 목록 복사",
      "아래 구성 이름은 app_main/CMakeLists.txt. 뒤의 접미사다.",
      "tests/dashboard/CMakeLists.txt는 별도 상대 경로다.",
      "현재 진입점 심볼릭 링크는 media-test 구성의 별칭이며 독립 구성으로 중복 집계하지 않는다.",
      "활성 목록과 주석 목록에 없는 매크로는 “선언 없음”으로 처리한다.",
      "CMake 파일에 선언이 없다는 사실과 외부 컴파일 옵션까지 고려한 최종 미정의 상태는 구분한다.",
      "빌드 생성물과 편집기 임시 파일은 분석에서 제외했다.",
      "host 설명 주석에만 나오는 TEST, ONNX_GPU, HEAD_TRACKER 등은 실제 add_compile_definitions(...) 선언이 없어 47종에 포함하지 않았다.",
      "다른 서버에서는 원본 절대 경로 링크를 사용하지 말고, 아래 저장소 상대 경로를 근거 텍스트로 표시한다."
    ]
  }
];
export function macroStatus(config: BuildConfiguration, name: string): MacroStatus {
  return config.active.includes(name) ? 'active' : config.commented.includes(name) ? 'commented' : 'absent';
}
export const statusLabels: Record<MacroStatus, string> = { active: '● 활성', commented: '◐ 주석 처리', absent: '— 선언 없음' };
export const analysisData = { analysisDate, sourceFileCount: 17, entrySymlinkCount: 1, entryPoint: 'app_main/CMakeLists.txt', linkTarget: 'CMakeLists.txt.adddi_rk3588_cmsv2_media_test', macros, configurations, findings };
